// extracted by mini-css-extract-plugin
export default {"TwoDimsFeature":"we_a bhp_b bhp_we"};